// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.brand-container {
  display: flex;
  align-items: center;
}

.brand-name {
  margin-left: 10px;
}

.navbar-toggler {
  margin-left: auto;
}

.navbar {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 20px;
  padding: 12px 0;
  border-bottom: #171717;
  box-shadow: 0 1px 2px 0 #535353;
}

.navbar-brand {
  font-size: 1.75rem;
  font-weight: normal;
  color: #1A1A86;
  display: inline block;
  margin-right: 10px;
}

.brand-name {
  margin-top: 8px;
  margin-left: 8px;
}

ul {
  position: absolute;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  display: flex;
}
ul li {
  margin: 0 30px;
  position: relative;
}
ul li a {
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-size: 1.1rem;
  line-height: 1;
  font-weight: 400;
  position: relative;
  z-index: 1;
  text-align: center;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, #0080ff, #0080ff 50%, #ffffff 50%);
  background-size: 200% 100%;
  background-position: -100%;
  transition: all 0.3s ease-in-out;
}
ul li a:before {
  display: block;
  content: "";
  width: 0;
  height: 2px;
  bottom: 5px;
  left: 0;
  bottom: -3px;
  z-index: 0;
  position: absolute;
  background: #0080ff;
  transition: all 0.3s ease-in-out;
}
ul li a:hover {
  background-position: 0%;
}
ul li a:hover:before {
  width: 100%;
}

.loginbtn {
  margin-left: 50px;
}

.loginbtn a {
  color: #0080ff;
  border: 1px solid #0080ff;
  font-size: 1rem;
  font-weight: 500;
}

.loginbtn a:hover {
  color: #f8f9fa;
  background-color: #0080ff;
  box-shadow: 0 4px 8px rgba(100, 149, 237, 0.5);
  transition-duration: 0.3s;
}

.requestbtn {
  margin-left: 35px;
}

.requestbtn a {
  width: 150px;
  padding: 6px 10px;
  font-weight: 500;
  background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);
  border: 1px solid #38393a;
  color: #171717;
}

.requestbtn a:hover {
  background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);
  box-shadow: 0 4px 8px rgba(100, 149, 237, 0.5);
}

.products i {
  display: inline;
}

.dropdown-toggle {
  color: #0080ff;
}

.navbar-toggler:hover {
  box-shadow: 0 0 15px #a1a1a1, 0 0 5px #a1a1a1, 0 0 10px #a1a1a1, 0 0 15px #a1a1a1;
  transition-duration: 0.3s;
}

@media (max-width: 990px) {
  .navbar-nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to the left */
    width: 100%;
    padding-left: 15px; /* Add some left padding for spacing */
    text-align: left;
  }
  .navbar-collapse {
    background: #171717; /* Adjust to match your navbar theme */
    padding: 10px;
  }
  ul {
    position: static;
    transform: none;
    display: block;
    width: 100%;
  }
  .loginbtn,
  .requestbtn {
    margin-left: 15px;
    width: 100%;
    text-align: left;
    margin-top: 10px;
    padding-left: 15px; /* Ensure buttons align with the menu */
  }
}
@media (max-width: 1450px) {
  ul {
    left: 60%;
  }
  .requestbtn {
    margin-right: 20px;
  }
}
@media (max-width: 1000px) {
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .brand-container {
    display: flex;
    align-items: center;
  }
  .brand-name {
    margin-left: 10px;
  }
  .navbar-toggler {
    margin-left: auto;
  }
  .navbar-collapse {
    background: #171717;
    padding: 10px;
  }
  .navbar-nav {
    width: 100%;
    padding-left: 15px;
    text-align: left;
  }
  ul {
    position: static;
    transform: none;
    display: block;
    width: 100%;
  }
  .loginbtn,
  .requestbtn {
    margin-left: 15px;
    width: 100%;
    text-align: left;
    margin-top: 10px;
    padding-left: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAKA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EAEA,sBAAA;EACA,+BAAA;AAHF;;AAQA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;AALF;;AAUA;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AARF;AASE;EACE,cAAA;EACA,kBAAA;AAPJ;AASI;EACE,eAAA;EACA,qBAAA;EACA,qBAAA;EAGA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,8EAAA;EAKA,0BAAA;EACA,0BAAA;EACA,gCAAA;AAbN;AAcM;EACE,cAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAZR;AAgBM;EACE,uBAAA;AAdR;AAeQ;EACE,WAAA;AAbV;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EAEE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,yBAAA;EACA,8CAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,YAAA;EAEA,iBAAA;EACA,gBAAA;EAGD,6DAAA;EAEC,yBAAA;EACA,cAAA;AAvBF;;AAyBA;EACE,6DAAA;EACA,8CAAA;AAtBF;;AA0BA;EACE,eAAA;AAvBF;;AAyBA;EACE,cAAA;AAtBF;;AA8BA;EACE,iFAAA;EACF,yBAAA;AA3BA;;AA8BA;EACE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA,EAAA,4BAAA;IACA,WAAA;IACA,kBAAA,EAAA,sCAAA;IACA,gBAAA;EA3BF;EA8BA;IACE,mBAAA,EAAA,sCAAA;IACA,aAAA;EA5BF;EA+BA;IACE,gBAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;EA7BF;EAgCA;;IAEE,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA,EAAA,uCAAA;EA9BF;AACF;AAiCA;EACE;IACE,SAAA;EA/BF;EAiCA;IACE,kBAAA;EA/BF;AACF;AAmCA;EACE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,WAAA;EAjCF;EAoCA;IACE,aAAA;IACA,mBAAA;EAlCF;EAqCA;IACE,iBAAA;EAnCF;EAsCA;IACE,iBAAA;EApCF;EAuCA;IACE,mBAAA;IACA,aAAA;EArCF;EAwCA;IACE,WAAA;IACA,kBAAA;IACA,gBAAA;EAtCF;EAyCA;IACE,gBAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;EAvCF;EA0CA;;IAEE,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EAxCF;AACF","sourcesContent":[".container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between; // Ensures logo+brand are left, menu icon is right\r\n  width: 100%;\r\n}\r\n\r\n.brand-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.brand-name {\r\n  margin-left: 10px; // Adds space between logo and brand name\r\n}\r\n\r\n.navbar-toggler {\r\n  margin-left: auto; // Pushes the menu icon to the rightmost side\r\n}\r\n\r\n\r\n\r\n\r\n.navbar {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  line-height: 20px;\r\n  padding: 12px 0;\r\n  //background: #f8f9fa;\r\n  border-bottom:  #171717;\r\n  box-shadow: 0 1px 2px 0 #535353;\r\n}\r\n\r\n\r\n\r\n.navbar-brand {\r\n  font-size: 1.75rem;\r\n  font-weight: normal;\r\n  color: #1A1A86;\r\n  display:inline block;\r\n  margin-right: 10px;\r\n\r\n}\r\n.brand-name{\r\n  margin-top: 8px;\r\n  margin-left: 8px;\r\n}\r\n\r\n\r\n\r\nul {\r\n  \r\n  position: absolute;\r\n  top: 50%;\r\n  left: 62%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  li{\r\n    margin:0 30px;\r\n    position:relative;\r\n    \r\n    a{\r\n      cursor: pointer;\r\n      text-decoration:none;\r\n      display:inline-block;\r\n      \r\n      //font-family:'Open Sans';\r\n      font-size: 1.1rem;\r\n      line-height:1;\r\n      font-weight:400;\r\n      position:relative;\r\n      z-index:1;\r\n      text-align: center;\r\n      -webkit-background-clip: text;\r\n      -webkit-text-fill-color: transparent;\r\n      background-image: linear-gradient(\r\n          to right,\r\n          #0080ff,\r\n          #0080ff 50%,\r\n          #ffffff 50%);\r\n      background-size: 200% 100%;\r\n      background-position: -100%;\r\n      transition: all 0.3s ease-in-out;\r\n      &:before{\r\n        display:block;\r\n        content:'';\r\n        width:0;\r\n        height:2px;\r\n        bottom:5px;\r\n        left:0;\r\n        bottom:-3px;\r\n        z-index:0;\r\n        position:absolute;\r\n        background:#0080ff;\r\n        transition: all 0.3s ease-in-out;\r\n\r\n      \r\n      }\r\n      &:hover{\r\n        background-position: 0%;\r\n        &:before{\r\n          width:100%;\r\n        }\r\n        \r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.loginbtn{\r\n  margin-left: 50px;\r\n  \r\n}\r\n.loginbtn a{\r\n  //padding:3px 8px;\r\n  color: #0080ff;\r\n  border: 1px solid #0080ff;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.loginbtn a:hover{\r\n  color: #f8f9fa;\r\n  background-color: #0080ff;\r\n  box-shadow: 0 4px 8px rgba(100, 149, 237, 0.50);\r\n  transition-duration: 0.3s;\r\n}\r\n\r\n.requestbtn{\r\n  margin-left: 35px;\r\n  \r\n}\r\n.requestbtn a{\r\n  width: 150px;\r\n // height: 33px;\r\n  padding:6px 10px;\r\n  font-weight: 500;\r\n  //background: linear-gradient(45deg, #ACB6E5 10%, #86FDE8 100%);\r\n //background: #91b3fa;\r\n background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);\r\n //box-shadow: 0 8px 12px 0 rgba(0,0,0,0.24),0 17px 50px 0 rgba(0,0,0,0.19);\r\n  border: 1px solid #38393a;\r\n  color: #171717;\r\n}\r\n.requestbtn a:hover{\r\n  background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);\r\n  box-shadow: 0 4px 8px rgba(100, 149, 237, 0.50);\r\n  //transition-duration: 0.3s;\r\n  \r\n}\r\n.products i{\r\n  display: inline;\r\n}\r\n.dropdown-toggle{\r\n  color: #0080ff;\r\n}\r\n\r\n// .navbar .navbar-toggler[aria-expanded=\"true\"] {\r\n  \r\n//   box-shadow: rgba(100, 149, 237, 0.55) 0px 5px 15px;\r\n  \r\n//   }\r\n.navbar-toggler:hover{\r\n  box-shadow: 0 0 15px #a1a1a1, 0 0 5px #a1a1a1, 0 0 10px #a1a1a1, 0 0 15px #a1a1a1;\r\ntransition-duration: 0.3s;\r\n}\r\n\r\n@media (max-width: 990px) {\r\n  .navbar-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start; /* Align items to the left */\r\n    width: 100%;\r\n    padding-left: 15px; /* Add some left padding for spacing */\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar-collapse {\r\n    background: #171717; /* Adjust to match your navbar theme */\r\n    padding: 10px;\r\n  }\r\n\r\n  ul {\r\n    position: static;\r\n    transform: none;\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .loginbtn,\r\n  .requestbtn {\r\n    margin-left: 15px;\r\n    width: 100%;\r\n    text-align: left;\r\n    margin-top: 10px;\r\n    padding-left: 15px; /* Ensure buttons align with the menu */\r\n  }\r\n}\r\n\r\n@media (max-width: 1450px){\r\n  ul{\r\n    left: 60%;\r\n  }\r\n  .requestbtn{\r\n    margin-right: 20px;\r\n  }\r\n}\r\n  \r\n\r\n@media (max-width: 1000px) {\r\n  .container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between; // Ensures logo+brand are left, menu icon is right\r\n    width: 100%;\r\n  }\r\n\r\n  .brand-container {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .brand-name {\r\n    margin-left: 10px; // Adds space between logo and brand name\r\n  }\r\n\r\n  .navbar-toggler {\r\n    margin-left: auto; // Pushes the menu icon to the rightmost side\r\n  }\r\n\r\n  .navbar-collapse {\r\n    background: #171717;\r\n    padding: 10px;\r\n  }\r\n\r\n  .navbar-nav {\r\n    width: 100%;\r\n    padding-left: 15px;\r\n    text-align: left;\r\n  }\r\n\r\n  ul {\r\n    position: static;\r\n    transform: none;\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .loginbtn,\r\n  .requestbtn {\r\n    margin-left: 15px;\r\n    width: 100%;\r\n    text-align: left;\r\n    margin-top: 10px;\r\n    padding-left: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
